import { defineMessages } from 'react-intl';

export const tooltipMessageTypes = Object.freeze({
  MORE: 'more',
  EXPLICIT: 'explicit',
  CLEAN: 'clean',
  UNAVAILABLE: 'unavailable',
});

export const tooltipMessages = defineMessages({
  more: {
    id: 'more',
    defaultMessage: 'More',
  },
  explicit: {
    id: 'explicit',
    defaultMessage: 'Explicit',
  },
  clean: {
    id: 'clean',
    defaultMessage: 'Clean',
  },
  unavailable: {
    id: 'unavailable',
    defaultMessage: 'Unavailable',
  },
});
